import moment from 'moment';

export const getYearsAsStrings = () => {
  const l = moment().year();
   let y = [{ text: '', value: ''}];

  for (let i = 1918; i <= l; i += 1) {
    y.push({ text: i, value: i.toString()});
  }

  return y;
};



// WEBPACK FOOTER //
// ./src/common/utils/data/years.js